/** designers / API 返回的常见人名字段 */
export interface UserDisplayFields {
  nick_name?: string;
  nickname?: string;
  username?: string;
  email?: string;
}

/** 列表、详情里按 uid 查 users 映射展示昵称 */
export function displayUserName(
  uid: string | undefined,
  users: Record<string, UserDisplayFields>,
): string {
  if (!uid) return "-";
  const u = users[uid];
  if (!u) return uid;
  return (
    u.nick_name ||
    u.nickname ||
    u.username ||
    u.email ||
    uid
  );
}

/** 已有用户对象（无映射）时展示昵称，例如下拉选项、当前登录 user */
export function displayNameFromFields(
  u?: (UserDisplayFields & { id?: string }) | null,
  fallback?: string,
): string {
  if (!u) return fallback ?? "";
  return (
    u.nick_name ||
    u.nickname ||
    u.username ||
    u.email ||
    u.id ||
    fallback ||
    ""
  );
}
